// Central config for the Trades & Property Maintenance Membership.
// Update the WhatsApp number to your real support line.
export const MEMBERSHIP = {
  price: 19.99,
  priceLabel: "£19.99",
  interval: "month",
  whatsappNumber: "447447929712", // international format, digits only
  whatsappMessage:
    "Hi Sortable, I'm a member and I need emergency contractor advice.",
};

export const whatsappLink = () =>
  `https://wa.me/${MEMBERSHIP.whatsappNumber}?text=${encodeURIComponent(
    MEMBERSHIP.whatsappMessage,
  )}`;

export const MEMBERSHIP_BENEFITS = [
  {
    title: "Monthly DIY maintenance guides",
    description:
      "A new practical guide every month covering seasonal property maintenance, delivered in-app and by email.",
  },
  {
    title: "Emergency contractor advice by WhatsApp",
    description:
      "Message our team when something goes wrong and get straight talking advice on what to do next.",
  },
  {
    title: "Discounted call-outs from local trades",
    description:
      "Your 3% booking fee is waived on every job you book through Sortable — that pays for itself fast.",
  },
  {
    title: 'Quote checking service',
    description:
      "Send us any quote and we'll tell you whether the price is fair for the work and your area.",
  },
  {
    title: "Access to trusted contractor directory",
    description:
      "Browse our verified, insurance-approved tradesmen with ratings and coverage areas.",
  },
];
